<template>
  <Page>
    <NavBar title="操作说明" />
    <main class="operation-guide">
      <header class="guide-header">
        <h1 class="text-20 font-500 text-main">电子税务局 APP 操作指引</h1>
        <p class="mt-8 text-14 leading-20 text-muted">请按以下步骤完成电子税务局 APP 的注册、实名和活体认证。</p>
      </header>

      <section v-for="(step, index) in steps" :key="step.title" class="guide-section">
        <div class="guide-section-title">
          <span class="step-index text-14 font-500 text-white">{{ index + 1 }}</span>
          <h2 class="text-16 font-500 text-main">{{ step.title }}</h2>
        </div>

        <p
          v-for="(description, descriptionIndex) in step.descriptions"
          :key="descriptionIndex"
          class="guide-text text-14 leading-20 text-main"
        >
          {{ description }}
        </p>

        <div v-if="step.images.length" class="guide-images">
          <img
            v-for="guideImage in step.images"
            :key="guideImage.src"
            class="guide-image"
            :src="guideImage.src"
            :alt="guideImage.alt"
            loading="lazy"
          />
        </div>
      </section>
    </main>
  </Page>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import NavBar from '@/components/NavBar/index.vue';
import appSearchImage from '@/assets/operation-guide/01-app-search.png';
import selectHubeiImage from '@/assets/operation-guide/02-select-hubei.png';
import myLoginImage from '@/assets/operation-guide/03-my-login.png';
import registerImage from '@/assets/operation-guide/04-register.png';
import agreementImage from '@/assets/operation-guide/05-agreement.png';
import identityImage from '@/assets/operation-guide/06-identity.png';
import phoneVerifyImage from '@/assets/operation-guide/07-phone-verify.png';
import passwordImage from '@/assets/operation-guide/08-password.png';
import registerSuccessImage from '@/assets/operation-guide/09-register-success.png';
import realNameLevelImage from '@/assets/operation-guide/10-real-name-level.png';
import unbindRelationImage from '@/assets/operation-guide/11-unbind-relation.png';
import liveAuthImage from '@/assets/operation-guide/12-live-auth.png';

const image = (src, alt) => ({ src, alt });

const steps = [
  {
    title: '下载安装“电子税务局”APP',
    descriptions: ['在手机应用商店搜索“电子税务局”并下载安装。'],
    images: [image(appSearchImage, '手机应用商店搜索电子税务局')]
  },
  {
    title: '选择省份城市',
    descriptions: ['下载完成后打开 APP，选择“湖北”。'],
    images: [image(selectHubeiImage, '电子税务局 APP 选择湖北')]
  },
  {
    title: '进入登录页面',
    descriptions: ['点击“我的”，再点击“立即登录”。'],
    images: [image(myLoginImage, '电子税务局 APP 我的页面和立即登录入口')]
  },
  {
    title: '注册电子税务局账号',
    descriptions: [
      '新用户点击“用户注册”，已注册用户可以直接登录。',
      '1. 点击“用户注册”。',
      '2. 勾选协议，点击“下一步”。',
      '3. 输入本人身份信息，点击“下一步”。',
      '4. 选择“实名手机号验证”，然后点击“下一步”。',
      '5. 设置密码，点击“下一步”。',
      '6. 注册成功后，点击“去登录”。'
    ],
    images: [
      image(registerImage, '电子税务局 APP 用户注册入口'),
      image(agreementImage, '电子税务局 APP 勾选协议并下一步'),
      image(identityImage, '电子税务局 APP 输入身份信息'),
      image(phoneVerifyImage, '电子税务局 APP 选择实名手机号验证'),
      image(passwordImage, '电子税务局 APP 设置登录密码'),
      image(registerSuccessImage, '电子税务局 APP 注册成功并去登录')
    ]
  },
  {
    title: '确认实名等级并完成活体认证',
    descriptions: [
      '1. 点击“我的”，查看实名等级是否为“四级”。如果是“四级”，操作完成；如果是“三级”，继续以下步骤。',
      '2. 点击“首页”，进入“解除相关人员关联关系”。',
      '3. 勾选协议，点击“确认”，进入活体认证流程。',
      '4. 完成认证后等待 5 分钟，再次进入“我的”查看实名等级。显示为“四级”后，操作结束。'
    ],
    images: [
      image(realNameLevelImage, '电子税务局 APP 查看实名等级'),
      image(unbindRelationImage, '电子税务局 APP 解除相关人员关联关系'),
      image(liveAuthImage, '电子税务局 APP 进入活体认证流程')
    ]
  }
];

export default defineComponent({
  name: 'WaybillOperationGuide',
  components: { NavBar },
  setup() {
    return { steps };
  }
});
</script>

<style lang="less" scoped>
.operation-guide {
  min-height: 100%;
  padding: 0.16rem 0.12rem 0.32rem;
  background: #f5f6f9;
}

.guide-header {
  padding: 0.04rem 0.12rem 0.16rem;
}

.guide-section {
  padding: 0.16rem 0.12rem;
  margin-bottom: 0.12rem;
  background: #fff;
  border-radius: 0.04rem;
}

.guide-section:last-child {
  margin-bottom: 0;
}

.guide-section-title {
  display: flex;
  align-items: center;
  min-height: 0.24rem;
}

.step-index {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 0.08rem;
  background: #0076ff;
  border-radius: 50%;
}

.guide-text {
  margin-top: 0.12rem;
}

.guide-images {
  margin-top: 0.12rem;
}

.guide-image {
  display: block;
  width: 100%;
  height: auto;
  margin-top: 0.08rem;
  background: #f5f6f9;
  border: 1px solid #eeeeee;
  border-radius: 0.04rem;
}

.guide-image:first-child {
  margin-top: 0;
}
</style>
